import React, { useEffect, useMemo, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { toast } from 'react-toastify';
import MainLayout from '../../components/Layout/MainLayout';
import reportsService from '../../services/reportsService';

const SummaryReportPage = () => {
  const [loading, setLoading] = useState(true);
  const [summary, setSummary] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await reportsService.getSummaryReport();
      if (response.success) {
        setSummary(response.data);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Failed to load summary report');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const chartData = useMemo(() => {
    if (!summary) return [];
    return [
      { name: 'HRs', value: summary.totalHRs },
      { name: 'Candidates', value: summary.totalCandidates },
      { name: 'Interviews', value: summary.totalInterviews },
      { name: 'Exams', value: summary.totalExams },
      { name: 'Selected', value: summary.totalSelected },
      { name: 'Rejected', value: summary.totalRejected }
    ];
  }, [summary]);

  return (
    <MainLayout>
      <div className="max-w-7xl mx-auto p-4 space-y-6">
        <h1 className="text-3xl font-bold text-charcoal">Summary Dashboard</h1>

        {loading ? (
          <div className="bg-white rounded-xl p-8 shadow-sm text-center text-gray-600">Loading summary report...</div>
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              <StatCard label="Total HRs" value={summary?.totalHRs || 0} />
              <StatCard label="Total Candidates" value={summary?.totalCandidates || 0} />
              <StatCard label="Total Interviews" value={summary?.totalInterviews || 0} />
              <StatCard label="Total Exams" value={summary?.totalExams || 0} />
              <StatCard label="Total Selected" value={summary?.totalSelected || 0} />
              <StatCard label="Total Rejected" value={summary?.totalRejected || 0} />
              {/* <StatCard label="Payments Count" value={summary?.totalPaymentsCount || 0} />
              <StatCard label="Payments Amount" value={`₹${summary?.totalPaymentsAmount || 0}`} /> */}
            </div>

            <div className="bg-white rounded-xl shadow-sm p-5">
              <h2 className="text-lg font-semibold text-charcoal mb-4">KPI Distribution</h2>
              <div className="h-72">
                <ResponsiveContainer width="100%" height="100%">
                  <BarChart data={chartData}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis allowDecimals={false} />
                    <Tooltip />
                    <Bar dataKey="value" fill="#7A8B5B" radius={[6, 6, 0, 0]} />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </div>
          </>
        )}
      </div>
    </MainLayout>
  );
};

const StatCard = ({ label, value }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4">
    <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
    <p className="text-2xl mt-2 font-semibold text-charcoal">{value}</p>
  </div>
);

export default SummaryReportPage;
